import btnStyle from '@/components/Shares/Button.module.css';
import inputStyle from '@/components/Shares/Input.module.css';
import { gunterzBold } from '@/theme/fonts';
import { useLingui } from '@lingui/react';
import { ActionIcon, Avatar, Box, Button, Card, Flex, Group, Input, Stack, Text, Transition, rem } from '@mantine/core';
import { useFocusWithin } from '@mantine/hooks';
import { IconPencil } from '@tabler/icons-react';
import { useState } from 'react';
export const InfoUsernameCard: React.FC = () => {
  const {
    i18n
  } = useLingui();
  const {
    ref,
    focused
  } = useFocusWithin();
  const [name, setName] = useState<string | undefined>(undefined);
  const [saved, setSaved] = useState(false);
  const handleSaved = (name: string | undefined) => {
    setSaved(!saved);
    !name ? console.log('name invalid') : console.log('username: ', name);
  };
  return <Card h="100%" radius={5} bg="var(--bg-400)" p={{
    base: 10,
    sm: 20
  }}>
      <Flex direction={{
      base: 'column',
      sm: 'row'
    }} py={18} gap={24}>
        <Box w={{
        base: 100,
        sm: 105
      }} h={{
        base: 100,
        sm: 105
      }} pos="relative">
          <Avatar src="/assets/user_avatar.png" w={{
          base: 100,
          sm: 105
        }} h={{
          base: 100,
          sm: 105
        }} />
          <ActionIcon size="md" radius="lg" pos="absolute" inset="auto 0px 0px auto">
            <IconPencil size={20} color="var(--text-white)" />
          </ActionIcon>
        </Box>

        <Stack gap={10} flex={1}>
          <Text fz={{
          base: rem(14),
          sm: rem(18)
        }} className={gunterzBold.className}>
            {i18n._('Username')}
          </Text>
          <Text fz={rem(12)} tt="uppercase" fw={700} c="var(--text-color-dark-theme)">
            {i18n._('You can change your username ')}

            {saved ? <Text span inherit c="var(--text-prime)">
                {i18n._('once every 90 days')}
              </Text> : <Text span inherit c="var(--text-prime)">
                {i18n._('in 23 days')}
              </Text>}
          </Text>
          <Group w="100%" gap={10}>
            <Input flex={1} ref={ref} classNames={{
            input: inputStyle.input_style_2
          }} placeholder={i18n._('Enter username')} value={name} onChange={event => setName(event.currentTarget.value)} disabled={saved} />
            <Transition mounted={focused} transition="fade-left" duration={250} timingFunction="ease">
              {styles => <Button style={styles} h={40} w={96} fz={11} classNames={{
              root: btnStyle.root
            }} onClick={() => handleSaved(name)}>
                  {i18n._('Save')}
                </Button>}
            </Transition>
          </Group>
        </Stack>
      </Flex>
    </Card>;
};